module.exports = __webpack_public_path__ + "img/recommended-rakuten-mobile-icon.1bdb92b2.png";